import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {MxMaterialModule} from '../../material/mx-material.module';
import {MxInfoTooltipComponent} from './components/mx-info-tooltip.component';

@NgModule({
    imports: [
        MxMaterialModule,
        CommonModule,
        RouterModule,
        TranslateModule
    ],
  exports: [MxInfoTooltipComponent],
  declarations: [MxInfoTooltipComponent]
})
export class MxInfoTooltipModule { }
